// Упрощенный JavaScript для управления видео
document.addEventListener('DOMContentLoaded', function() {
  // Инициализация всех видеоплееров
  const videoPlayers = document.querySelectorAll('.video-player');

  videoPlayers.forEach(player => {
    const video = player.querySelector('.swiper-video');
    const posterOverlay = player.querySelector('.video-poster-overlay');

    // Переключение воспроизведения
    function togglePlay() {
      if (video.paused) {
        video.play();
        player.classList.add('playing');
      } else {
        video.pause();
        player.classList.remove('playing');
      }
    }

    // Клик по видео или постеру
    player.addEventListener('click', function(e) {
      // Если клик по оверлею или видео
      togglePlay();
    });

    // Пауза при переключении слайдов Swiper
    const swiperInstance = player.closest('.swiper').swiper;
    if (swiperInstance) {
      swiperInstance.on('slideChange', function() {
        if (!video.paused) {
          video.pause();
          player.classList.remove('playing');
        }
      });
    }

    // Остановка видео при скролле за пределы видимости
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && !video.paused) {
          video.pause();
          player.classList.remove('playing');
        }
      });
    }, { threshold: 0.5 });

    observer.observe(player);
  });

  // Автопауза всех видео при переключении табов
  const tabButtons = document.querySelectorAll('.tabs__nav-btn');
  const videoElements = document.querySelectorAll('.swiper-video');

  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Пауза всех видео
      videoElements.forEach(video => {
        if (!video.paused) {
          video.pause();
          const player = video.closest('.video-player');
          if (player) {
            player.classList.remove('playing');
          }
        }
      });
    });
  });
});
